import { SET_TRACKING_DATA_TYPE } from '../../constants/action_types';
import { TRACKING_DEFAULT_PARAMS } from '../../constants/tracking';
import { TReduxActions } from '../../types/redux';
import { ITracking } from '../../types/tracking';

export function trackingReducer(state: ITracking = TRACKING_DEFAULT_PARAMS, action: TReduxActions): ITracking {
  switch (action.type) {
    case SET_TRACKING_DATA_TYPE:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
}
